import store from '@/store';
import { isEmpty } from '@/common/utils/Util';

const updateRouteLayout = async meta => {
  await store.dispatch('layout/updateRouteLayout', {
    isHeader: meta.isHeader,
    isHeaderPrimary: meta.isHeaderPrimary,
    titleName: meta.titleName,
    isHome: meta.isHome,
    isBack: meta.isBack,
    isLike: meta.isLike,
    isNav: meta.isNav,
    isGlass: meta.isGlass,
    isSearchHeader: meta.isSearchHeader,
    isFilter: meta.isFilter,
    isShare: meta.isShare,
    isAnnouncementShare: meta.isAnnouncementShare,
    isAnnouncementKakaoShare: meta.isAnnouncementKakaoShare,
    isSmileShare: meta.isSmileShare,
    isSmileKakaoShare: meta.isSmileKakaoShare,
    isInvitationShare: meta.isInvitationShare,
    isInvitationKakaoShare: meta.isInvitationKakaoShare,
    isBusinessLike: meta.isBusinessLike,
    isBusinessKakaoShare: meta.isBusinessKakaoShare,
    isBusinessShare: meta.isBusinessShare,
    isBizDetailShare: meta.isBizDetailShare,
    isBusinessSubscribe: meta.isBusinessSubscribe,
    isBusinessMarketingShare: meta.isBusinessMarketingShare,
    isBusinessMarketingKakaoShare: meta.isBusinessMarketingKakaoShare,
    isBusinessDonationShare: meta.isBusinessDonationShare,
    isBusinessDonationKakaoShare: meta.isBusinessDonationKakaoShare,
    isBusinessJobKakaoShare: meta.isBusinessJobKakaoShare,
    isBusinessJobShare: meta.isBusinessJobShare,
    isFuneralShare: meta.isFuneralShare,
    isFuneralKakaoShare: meta.isFuneralKakaoShare,
    isMemorialKakaoShare: meta.isMemorialKakaoShare,
    isMemorialShare: meta.isMemorialShare,
    isExcel: meta.isExcel,
    subName: meta.subName,
    isBell: meta.isBell,
    isSetting: meta.isSetting,
    isFooter: meta.isFooter,
    isPlus: meta.isPlus,
    isEdit: meta.isEdit,
    isDelete: meta.isDelete,
    isGreen: meta.isGreen
  });
};

export const updateLayout = async (to, from, next) => {
  let meta = to.meta;
  if (!isEmpty(store.getters['layout/getModalAlertComponents'])) {
    /** watch route 이동시 side-bar, modal close **/
    await store.dispatch('layout/removeAllModalAlertComponent');
  }
  if (!isEmpty(store.getters['layout/getModalComponents'])) {
    await store.dispatch('layout/removeAllModalComponent');
  }
  await updateRouteLayout(meta);
};
